import { render, staticRenderFns } from "./BtnAtivarDesativarItem.vue?vue&type=template&id=f1980896"
import script from "./BtnAtivarDesativarItem.vue?vue&type=script&lang=js"
export * from "./BtnAtivarDesativarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports